import { requiredIf } from 'vuelidate/lib/validators'
export default {
    evaluation: {
        id: {},
        type: {},
        status: {},
        isOpen: {},
        can_edit: {},
        evaluated: {},
        is_editing: {},
        can_decline: {},
        questionnaire_id: {},
        questionnaire_title: {},
        questionnaire_is_closed: {},
        sendingEvaluationLoader: {},
        decliningEvaluationLoader: {},
        acceptingEvaluationLoader: {},
        enableEvaluationEditionLoader: {},
        values: {
            $each: {
                id: {},
                title: {},
                picture: {},
                description: {},
            },
        },
        answers: {
            required: requiredIf(vm => vm.comments.length === 0),
            $each: {
                id: {},
                degrees: {},
                value_id: {},
                is_nullable: {},
                is_required: {},
                scale_id: {},
                scale_format: {},
                key_behavior_id: {},
                key_behavior_title: {},
                score: {},
                degree_id: {},
                not_able_to_answer: {},
                score_id: {
                    required: requiredIf(vm => {
                        if (vm.is_required && vm.is_nullable) {
                            return (
                                vm.score == null &&
                                vm.not_able_to_answer == false
                            )
                        }

                        if (vm.is_nullable && !vm.is_required) {
                            return false
                        }

                        return vm.is_required
                    }),
                },
            },
        },
        comments: {
            required: requiredIf(vm => vm.answers.length === 0),
            $each: {
                title: {},
                is_required: {},
                commentable_id: {},
                commentable_type: {},
                questionnaire_comment_id: {},
                id: {
                    required: requiredIf(vm => vm.is_required),
                },
                content: {
                    required: requiredIf(vm => vm.is_required),
                },
            },
        },
    },
}
